import React, { useEffect } from 'react';

// REDUX
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getAuthenticateData } from '@Managers/Redux/HttpState';

// CSS
import styles from '@UILayer/UILayer.scss';

// MODULES
import GameComponent from '@Game/GameComponent';

const GameContainer: React.FC<{}> = ({}) => {
    const authData = useAppSelector(getAuthenticateData);

    useEffect(() => {
        EventsCenter.emit(EGameEvents.GAME_INSTANCE_READY, authData);
    }, []);

    return (
        <div className={styles.game_container}>
            <GameComponent />
        </div>
    );
};

export default GameContainer;
